import React from "react";

export default function EventCardFilter() {
  return <div>EventCardEventCardFilter</div>;
}
